import { adminService } from 'core/services/adminService'
import { formatNumbers } from 'core/helpers/format-numbers'
import { useState } from 'react'
import { toast } from 'react-toastify'

import c from './assets/sass/advent-item.module.scss'

const REWARD_TYPES = {
    COINS: '💰 Монеты',
    ENERGY: '⚡ Энергия',
    PROMO_CASE: '🎁 Кейс',
    PROMO_SKIN: '🎨 Скин',
    PROMO_DEPOSIT: '💳 Депозит',
    PROMO_WHEEL: '🎰 Вращение',
    DEPOSIT_FREE_CASE: '📦 Кейс при депозите',
    PROMO_XP: '🌟 XP',
    PROMO_BALANCE: '💵 Баланс',
    GIFT: '🎉 Суперприз',
}

export const AdventItem = ({ reward, onEdit, onUpdate }) => {
    const [loading, setLoading] = useState(false)
    const [showBulkAdd, setShowBulkAdd] = useState(false)
    const [bulkCodes, setBulkCodes] = useState('')
    const [txtFile, setTxtFile] = useState(null)

    const toggleActive = async () => {
        try {
            setLoading(true)
            await adminService.updateAdventReward(reward.id, {
                ...reward,
                isActive: !reward.isActive,
            })
            toast('Статус обновлен', { type: 'success' })
            await onUpdate()
        } catch (error) {
            console.error('Toggle active error:', error)
            toast('Ошибка: ' + (error.response?.data?.error || error.message), {
                type: 'error',
            })
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async () => {
        if (!window.confirm(`Удалить награду дня ${reward.day}?`)) return
        try {
            setLoading(true)
            await adminService.deleteAdventReward(reward.id)
            toast('Награда удалена', { type: 'success' })
            await onUpdate()
        } catch (error) {
            console.error('Delete reward error:', error)
            toast('Ошибка: ' + (error.response?.data?.error || error.message), {
                type: 'error',
            })
        } finally {
            setLoading(false)
        }
    }

    const handleTxtFileChange = (e) => {
        const file = e.target.files[0]
        if (!file) return

        const reader = new FileReader()
        reader.onload = (event) => {
            const text = event.target.result
            const codes = text
                .split('\n')
                .map((c) => c.trim())
                .filter(Boolean)
            setTxtFile(codes)
        }
        reader.readAsText(file)
    }

    const handleBulkAdd = async () => {
        const codes =
            txtFile ||
            bulkCodes
                .split('\n')
                .map((c) => c.trim())
                .filter(Boolean)
        if (codes.length === 0) {
            toast('Добавьте промокоды', { type: 'warning' })
            return
        }

        try {
            setLoading(true)
            await adminService.addAdventPromoCodesBulk(reward.id, codes)

            if (reward.isReusable) {
                toast(
                    `✅ Добавлено ${codes.length} активаций к многоразовой награде`,
                    { type: 'success' }
                )
            } else {
                toast(`✅ Добавлено ${codes.length} промокодов к награде`, {
                    type: 'success',
                })
            }

            setBulkCodes('')
            setTxtFile(null)
            setShowBulkAdd(false)
            onUpdate()
        } catch (error) {
            toast('Ошибка: ' + error.message, { type: 'error' })
        } finally {
            setLoading(false)
        }
    }

    const needsPromoCode = !['COINS', 'ENERGY'].includes(
        reward.rewardType
    )

    return (
        <div className={c.component}>
            <div className={c.header}>
                <span className={c.type}>
                    {REWARD_TYPES[reward.rewardType] || reward.rewardType}
                </span>
            </div>
            <div className={c.content}>
                <span className={c.description}>{reward.description}</span>
                {(reward.rewardType === 'COINS' ||
                    reward.rewardType === 'ENERGY') && (
                    <span className={c.reward}>
                        Награда: {formatNumbers(parseInt(reward.reward))}
                    </span>
                )}
                {reward.promoCode && (
                    <span className={c.promo}>
                        Промокод: {reward.promoCode}
                    </span>
                )}
                {reward.promoStats && (
                    <span
                        className={c.promoStats}
                        style={{
                            color:
                                reward.promoStats.available > 0
                                    ? '#4CAF50'
                                    : '#f44336',
                        }}
                    >
                        Промокодов: {reward.promoStats.available}/
                        {reward.promoStats.total}
                        {reward.promoStats.isSharedPool && (
                            <span
                                style={{
                                    fontSize: '11px',
                                    opacity: 0.7,
                                    marginLeft: '6px',
                                }}
                            >
                                (общий пул)
                            </span>
                        )}
                    </span>
                )}
                <span className={c.chance}>Шанс: {reward.chance}%</span>
                {reward.isReusable ? (
                    <span className={c.stats} style={{ color: '#4CAF50' }}>
                        🔄 Многоразовая ({reward.currentActivations}/
                        {reward.maxActivations || '∞'})
                    </span>
                ) : (
                    <span className={c.stats}>
                        🎯 Индивидуальная - Забрано: {reward.claimedCount}
                    </span>
                )}
            </div>
            <div className={c.actions}>
                <button className={c.btn} onClick={onEdit}>
                    Редактировать
                </button>
                {needsPromoCode && (
                    <button
                        className={`${c.btn} ${c.btnInfo}`}
                        onClick={() => setShowBulkAdd(!showBulkAdd)}
                        disabled={loading}
                    >
                        {showBulkAdd ? 'Скрыть' : '+ Промокоды'}
                    </button>
                )}
                <button
                    className={`${c.btn} ${reward.isActive ? c.btnWarning : c.btnSuccess}`}
                    onClick={toggleActive}
                    disabled={loading}
                >
                    {reward.isActive ? 'Выключить' : 'Включить'}
                </button>
                <button
                    className={`${c.btn} ${c.btnDanger}`}
                    onClick={handleDelete}
                    disabled={loading}
                >
                    Удалить
                </button>
            </div>

            {showBulkAdd && needsPromoCode && (
                <div className={c.bulkAdd}>
                    <h4>Массовое добавление промокодов</h4>
                    <p
                        style={{
                            fontSize: '13px',
                            color: 'rgba(255,255,255,0.5)',
                            marginBottom: '8px',
                        }}
                    >
                        {reward.isReusable
                            ? 'Увеличит лимит активаций многоразовой награды'
                            : 'Добавит промокоды к этой награде (каждый для 1 юзера)'}
                    </p>
                    <textarea
                        value={bulkCodes}
                        onChange={(e) => setBulkCodes(e.target.value)}
                        placeholder="Один промокод на строку"
                        rows={5}
                        style={{
                            width: '100%',
                            padding: '8px',
                            borderRadius: '4px',
                            marginBottom: '8px',
                        }}
                    />
                    <input
                        type="file"
                        accept=".txt"
                        onChange={handleTxtFileChange}
                        style={{ marginBottom: '8px', display: 'block' }}
                    />
                    {txtFile && txtFile.length > 0 && (
                        <p style={{ fontSize: '13px', color: '#4CAF50' }}>
                            Загружено {txtFile.length} промокодов из файла
                        </p>
                    )}
                    <button
                        className={c.btn}
                        onClick={handleBulkAdd}
                        disabled={loading || (!bulkCodes && !txtFile)}
                    >
                        Добавить{' '}
                        {txtFile?.length ||
                            bulkCodes.split('\n').filter((c) => c.trim())
                                .length ||
                            0}{' '}
                        {reward.isReusable ? 'активаций' : 'промокодов'}
                    </button>
                </div>
            )}
        </div>
    )
}
